import { newShortId } from "@budgeter/shared";

/** "Logged in as X", trusted while offline (SPEC §11.4). The server decides validity on sync. */
export interface SessionMarker {
  userId: string;
  username: string;
  displayName: string;
  kind: string;
}

export const sessionKey = "budgeter.session";
const deviceKey = "budgeter.device";

export function readSession(): SessionMarker | null {
  try {
    const raw = localStorage.getItem(sessionKey);
    return raw ? (JSON.parse(raw) as SessionMarker) : null;
  } catch {
    return null;
  }
}

export function writeSession(marker: SessionMarker): void {
  localStorage.setItem(sessionKey, JSON.stringify(marker));
}

export function clearSession(): void {
  localStorage.removeItem(sessionKey);
}

/** A stable per-install ID, used to attribute changes to a device. */
export function deviceId(): string {
  let id = localStorage.getItem(deviceKey);
  if (!id) {
    id = newShortId();
    localStorage.setItem(deviceKey, id);
  }
  return id;
}
